export enum DroppedOffStatus {
  none = "none",
  complete = "complete",
  partial = "partial",
}
